import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.for-each.js";
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, withCtx as _withCtx } from "vue";
const _hoisted_1 = {
  class: "lc_ttop"
};
const _hoisted_2 = {
  class: "lc-bsinfo"
};
const _hoisted_3 = {
  style: {
    "padding-bottom": "50px"
  }
};
import { getCurrentInstance, reactive, ref, provide } from 'vue';
import { getBaseInfoFile, getComCurrentDate } from '../../../utils/lc_jx_utils/lc_jx.js';
import { cpPPT_defaultVal, cpppt_headerBtns, cpPPT_listHeader } from '../../../utils/lc_data'; // 获取人员
import { downloadMod } from '../../../utils/lc';
import { ElMessage } from 'element-plus';
import { useRoute } from 'vue-router';
/* 数据层 */

export default {
  __name: 'zlsh',
  setup(__props) {
    const route = useRoute();
    const ids = ref(route.query.prBasetaskId);
    const {
      proxy
    } = getCurrentInstance();
    provide('project_id', route.query.id);
    let remark = ref('');
    // 基本信息组件值
    const addBaseInfo = ref();
    const lcButtons = ref();
    // 详情数据
    let data = reactive({
      baseInfo: {},
      //富文本
      height: 300,
      key: '',
      id: ''
    });
    // 基本信息字段值
    let baseInfokeys = reactive({
      keyArry: ['sn', 'project_sn', 'name', 'required_time_text', 'status', 'leader_user_id', 'reviewer_user_id', 'task_status_text', 'examine_status_text', 'project_id', 'project_name', 'plan_start_time', 'plan_start_time_text', 'plan_end_time', 'plan_end_time_text', 'end_time_text']
    });

    // 市场分析PPT资料
    let cpPPTdata = reactive({
      tableTitle: '任务信息列表',
      tableHeigth: 180,
      loading: false,
      isShowLinksDialog: false,
      listHeader: JSON.parse(JSON.stringify(cpPPT_listHeader)),
      defaultRow: JSON.parse(JSON.stringify(cpPPT_defaultVal)),
      tableHeader: JSON.parse(JSON.stringify(cpppt_headerBtns)),
      notShowCol: [],
      beforeStrList: [],
      staticList: {}
    });

    /* 初始化 */
    getPageInfo();
    /* 方法层 */
    // 物料报价详情
    function getPageInfo(value) {
      proxy.$http.get('project/task/file_review/info', {
        id: route.query.prBasetaskId
      }).then(res => {
        if (res.errno == 200) {
          data.baseInfo = JSON.parse(JSON.stringify(res.data));
          ids.value = res.data.id;
          // 上下文件管理列表
          cpPPTdata.defaultRow = res.data.files.file_review ? getBaseInfoFile(res.data.files.file_review) : [];
          //备注
          remark.value = res.data.remark;
          // 驳回原因
          addBaseInfo.value.data.reject = res.data && res.data.reject ? res.data.reject : '';
          // 基础信息
          baseInfokeys.keyArry.forEach(it => {
            addBaseInfo.value.taskform[it] = res.data[it];
          });
        } else {
          ElMessage({
            type: 'success',
            message: res.errmsg
          });
        }
      });
    }
    //按钮组操作
    function btsEmit(value) {
      // 提交和审核先做保存的动作
      if (value == 'passBt' || value == 'submitBt') {
        handelSavePage(value);
      }
      // 保存
      if (value == 'saveBt') {
        handelSavePage();
      }
    }
    // 保存页面
    function handelSavePage(bttype) {
      proxy.$http.showLoading(false).post('project/task/file_review/edit', {
        id: data.baseInfo.id,
        leader_user_id: addBaseInfo.value.taskform['leader_user_id'],
        reviewer_user_id: addBaseInfo.value.taskform['reviewer_user_id'],
        plan_start_time: addBaseInfo.value.taskform['plan_start_time_text'],
        plan_end_time: addBaseInfo.value.taskform['plan_end_time_text'],
        remark: remark.value,
        skus: data.ggdyTableData,
        files: {
          'file_review': cpPPTdata.defaultRow
        }
      }).then(res => {
        if (res.errno == 200) {
          ElMessage({
            type: 'success',
            message: res.errmsg
          });
          if (bttype == 'submitBt') {
            lcButtons.value.thesubmit(bttype);
          }
          if (bttype == 'passBt') {
            lcButtons.value.thepass(bttype);
          }
          getPageInfo();
        } else {
          ElMessage({
            type: 'error',
            message: res.errmsg
          });
        }
      });
    }
    // 表格按钮 -- 点击
    function getClickBtnType_ppt(type, selRow, code, allData) {
      //下载模板
      if (type == 'download') {
        downloadMod(data.baseInfo.basetask_id, '资料审核');
      }
      if (type == 'write_links') {
        cpPPTdata.isShowLinksDialogIndex = data.isShowLinksDialogIndex + 1;
        cpPPTdata.isShowLinksDialog = true;
        cpPPTdata.btnTamplteList = JSON.parse(JSON.stringify(allData));
      }
    }
    // 文件上传
    function uploadAddRow(s_list) {
      cpPPTdata.loading = true;
      let list = JSON.parse(JSON.stringify(s_list.table_list));
      list.push({
        id: 0,
        title: s_list.name,
        create_time: s_list.date,
        remark: '',
        url_type: 'file',
        isDownLoadShow: 'yes',
        url: s_list.url,
        downLoadUrl: s_list.url
      });
      cpPPTdata.defaultRow = list;
      setTimeout(() => {
        proxy.$message.success('文件上传成功');
        cpPPTdata.loading = false;
      }, 800);
    }
    //富文本编辑器
    function inputContent(value) {
      remark.value = value;
    }
    // 填写共享盘链接
    function getDragWriteData(val) {
      cpPPTdata.loading = true;
      cpPPTdata.btnTamplteList.push({
        id: 0,
        title: val,
        create_time: getComCurrentDate(),
        remark: '',
        url_type: 'link',
        url: ''
      });
      cpPPTdata.defaultRow = cpPPTdata.btnTamplteList;
      setTimeout(() => {
        proxy.$message.success('链接添加成功');
        cpPPTdata.loading = false;
      }, 800);
    }
    return (_ctx, _cache) => {
      const _component_LcButtons = _resolveComponent("LcButtons");
      const _component_lcBaseInfo = _resolveComponent("lcBaseInfo");
      const _component_lcwjsc = _resolveComponent("lcwjsc");
      const _component_lctinymce = _resolveComponent("lctinymce");
      const _component_LcWriteLinks = _resolveComponent("LcWriteLinks");
      const _component_el_main = _resolveComponent("el-main");
      return _openBlock(), _createBlock(_component_el_main, {
        class: "bg_white wrap_box lc_rw"
      }, {
        default: _withCtx(() => [_createVNode(_component_LcButtons, {
          ref_key: "lcButtons",
          ref: lcButtons,
          type: 2,
          onBtsEmit: _cache[0] || (_cache[0] = $event => btsEmit($event)),
          planStratTime: _unref(data).baseInfo.plan_start_time_text,
          ids: ids.value,
          projectName: _unref(data).baseInfo.project_name,
          reviewerUserId: _unref(data).baseInfo.reviewer_user_id,
          userId: _unref(data).baseInfo.leader_user_id,
          msg: _unref(data).baseInfo.msg,
          onGetPageInfo: getPageInfo,
          deppgetPageInfo: getPageInfo
        }, null, 8, ["planStratTime", "ids", "projectName", "reviewerUserId", "userId", "msg"]), _createElementVNode("div", _hoisted_1, [_createVNode(_component_lcBaseInfo, {
          ref_key: "addBaseInfo",
          ref: addBaseInfo,
          type: "taskInfo"
        }, null, 512)]), _createElementVNode("div", _hoisted_2, [_cache[10] || (_cache[10] = _createElementVNode("div", {
          class: "lc_title lc_ttop lc_add_ggdyb"
        }, "输出文件", -1)), _createVNode(_component_lcwjsc, {
          loading: _unref(cpPPTdata).loading,
          "onUpdate:loading": _cache[1] || (_cache[1] = $event => _unref(cpPPTdata).loading = $event),
          tableHeigth: _unref(cpPPTdata).tableHeigth,
          "onUpdate:tableHeigth": _cache[2] || (_cache[2] = $event => _unref(cpPPTdata).tableHeigth = $event),
          listHeader: _unref(cpPPTdata).listHeader,
          "onUpdate:listHeader": _cache[3] || (_cache[3] = $event => _unref(cpPPTdata).listHeader = $event),
          defaultRow: _unref(cpPPTdata).defaultRow,
          "onUpdate:defaultRow": _cache[4] || (_cache[4] = $event => _unref(cpPPTdata).defaultRow = $event),
          tableHeader: _unref(cpPPTdata).tableHeader,
          "onUpdate:tableHeader": _cache[5] || (_cache[5] = $event => _unref(cpPPTdata).tableHeader = $event),
          notShowCol: _unref(cpPPTdata).notShowCol,
          "onUpdate:notShowCol": _cache[6] || (_cache[6] = $event => _unref(cpPPTdata).notShowCol = $event),
          staticList: _unref(cpPPTdata).staticList,
          "onUpdate:staticList": _cache[7] || (_cache[7] = $event => _unref(cpPPTdata).staticList = $event),
          beforeStrList: _unref(cpPPTdata).beforeStrList,
          "onUpdate:beforeStrList": _cache[8] || (_cache[8] = $event => _unref(cpPPTdata).beforeStrList = $event),
          onGetClickBtnType: getClickBtnType_ppt,
          onUploadAddRow: uploadAddRow
        }, null, 8, ["loading", "tableHeigth", "listHeader", "defaultRow", "tableHeader", "notShowCol", "staticList", "beforeStrList"]), _cache[11] || (_cache[11] = _createElementVNode("div", {
          class: "lc_ttop lc_bzt"
        }, "备注", -1)), _createElementVNode("div", _hoisted_3, [(_openBlock(), _createBlock(_component_lctinymce, {
          id: _unref(data).id,
          ref: "editor",
          height: _unref(data).height,
          "cur-value": _unref(remark),
          key: _unref(data).key,
          onInput: inputContent
        }, null, 8, ["id", "height", "cur-value"]))])]), (_openBlock(), _createBlock(_component_LcWriteLinks, {
          key: _unref(cpPPTdata).isShowLinksDialogIndex,
          isShowLinksDialog: _unref(cpPPTdata).isShowLinksDialog,
          "onUpdate:isShowLinksDialog": _cache[9] || (_cache[9] = $event => _unref(cpPPTdata).isShowLinksDialog = $event),
          onGetDragWriteData: getDragWriteData
        }, null, 8, ["isShowLinksDialog"]))]),
        _: 1
      });
    };
  }
};